<template>
  <unicom-linha class="linha-embaixo">
    <unicom-coluna sm="2" :class="espacamentoMobile">
      <div align="right">Espaço Viver Bem</div>
    </unicom-coluna>

    <unicom-coluna sm="1" :class="espacamentoMobile">
      <unicom-switch :value="clickSwitch" @input="toggleSwitch" />
    </unicom-coluna>

    <unicom-coluna sm="4" :class="espacamentoMobile">
      <Multiselect
        v-model="payload.tipoServicoEspecialidade"
        :propsMultiselect="{
          placeholder: 'Serviços Ofertados',
          options: listaEspecialidades,
          'track-by': 'id',
          label: 'tipoServicoEspecialidade'
        }"
        v-show="clickSwitch"
      />
    </unicom-coluna>

    <unicom-coluna
      sm="1"
      :class="espacamentoMobile"
      v-if="!outrosOpcao && clickSwitch"
    >
    </unicom-coluna>

    <unicom-coluna
      sm="1"
      :class="espacamentoMobile"
      v-if="outrosOpcao && clickSwitch"
    >
      <div align="right" style="font-size: 15px; padding-top: 8px">
        Outros:
      </div>
    </unicom-coluna>
    <unicom-coluna sm="4" :class="espacamentoMobile">
      <unicom-campo-texto
        ladoIcone="direito"
        clickIcone
        colorPlaceholder="#9E9E9E"
        :maxCaracteres="1500"
        placeholder="Outros Serviços"
        v-model="payload.outro"
        v-if="outrosOpcao && clickSwitch"
      />
    </unicom-coluna>

    <unicom-coluna sm="3" style="padding-top: 20px"> </unicom-coluna>

    <unicom-coluna sm="4" :class="espacamentoMobile" style="padding-top: 20px">
      <Multiselect
        v-model="payload.tipoServicoAbrangencia"
        :propsMultiselect="{
          placeholder: 'Programas Recomendados pela ANS',
          options: listaAbrangencias,
          'track-by': 'id',
          label: 'tipoServicoAbrangencia'
        }"
        v-show="clickSwitch"
      />
    </unicom-coluna>

    <unicom-coluna sm="4" :class="espacamentoMobile" style="padding-top: 20px">
      <single-select
        :value="payload.tipoServicoPublico"
        @input="atualizarServicoPublico"
        :propsSingleSelect="{
          placeholder: 'Programas de promoção e prevenção à Saúde',
          options: listaPublicoAlvo,
          'track-by': 'id',
          label: 'tipoServicoPublico'
        }"
        v-show="clickSwitch"
      />
    </unicom-coluna>
  </unicom-linha>
</template>

<script>
import Multiselect from "@/views/RecursosPropriosQuestionarios/shared/Multiselect.vue";
import SingleSelect from "@/views/RecursosPropriosQuestionarios/shared/Singleselect.vue";

import SharedMixin from "./SharedMixin.js";

export default {
  mixins: [SharedMixin],
  components: {
    Multiselect,
    SingleSelect
  },
  data() {
    return {
      payload: {
        tipoServico: "Espaço Viver Bem",
        tipoServicoEspecialidade: [],
        tipoServicoAbrangencia: [],
        tipoServicoPublico: null,
        outro: ""
      },
      listaEspecialidades: [],
      listaAbrangencias: [],
      outrosOpcao: false
    };
  },
  beforeMount() {
    this.inicializarEspecialidades();
    this.inicializarAbrangencias();
  },
  methods: {
    inicializarEspecialidades() {
      return this.getEspecialidades(this.servico.id).then(({ data }) => {
        if (data) {
          this.listaEspecialidades = [...data];
        }
      });
    },
    inicializarAbrangencias() {
      return this.getAbrangencia(this.servico.id).then(({ data }) => {
        if (data) {
          this.listaAbrangencias = [...data];
        }
      });
    }
  },
  watch: {
    "payload.tipoServicoAbrangencia": "emitir",
    "payload.tipoServicoPublico": "emitir",
    "payload.outro": "emitir",
    "payload.especialidadesOferecidas": "emitir",
    dadosServidor(newVal) {
      if (newVal.especialidades.length > 0) {
        newVal.especialidades.forEach(especialidade => {
          if (
            especialidade.tipoServico.tipoServico === this.payload.tipoServico
          ) {
            this.clickSwitch = true;
            this.preencheCampo(
              "especialidade",
              especialidade.tipoServicoEspecialidade
            );
            this.emitPayload({
              ...this.payload,
              clickSwitch: this.clickSwitch
            });
          }
        });
      }
      if (newVal.servicos.length > 0) {
        newVal.servicos.forEach(servico => {
          if (servico.tipoServico.tipoServico === this.payload.tipoServico) {
            this.clickSwitch = true;
            this.preencheCampo(
              "especialidades oferecidas",
              servico.especialidadesOferecidas
            );
            this.preencheCampo("publico", servico.tipoServicoPublico);
            this.preencheCampo("outro", servico.outro);
            this.emitPayload({
              ...this.payload,
              clickSwitch: this.clickSwitch
            });
          }
        });
      }
      if (newVal.abrangencias.length > 0) {
        newVal.abrangencias.forEach(abrangencia => {
          if (
            abrangencia.tipoServico.tipoServico === this.payload.tipoServico &&
            (abrangencia.tipoServicoAbrangencia || abrangencia.outroAbrangencia)
          ) {
            this.clickSwitch = true;
            this.preencheCampo(
              "abrangencia",
              abrangencia.tipoServicoAbrangencia
            );
            this.emitPayload({
              ...this.payload,
              clickSwitch: this.clickSwitch
            });
          }
        });
      }
    },
    outrosOpcao(novoValor) {
      if (novoValor == true && !this.payload.outro) {
        this.errors.outros = true;
      }
      if (!novoValor) {
        this.errors.outros = false;
      }
    }
  }
};
</script>

<style scoped>
.unicom-linha {
  margin-bottom: 24px;
}
.linha-embaixo {
  padding-bottom: 24px;
  border-bottom: 1px solid #ebebeb;
  margin-bottom: 24px;
}
#titulo {
  font-size: 15px;
  padding-top: 8px;
  text-align: center;
}

.procedimentos {
  margin: 1rem 0;
}
</style>
